import { OPEN_SUBMENU, CLOSE_SUBMENU } from "./subMenuActionTypes";

export const openSubMenu = (menuId) => ({
    type: OPEN_SUBMENU,
    payload: menuId,
});

export const closeSubMenu = () => ({
    type: CLOSE_SUBMENU,
});